import PortfolioMobile from 'components/PortfolioMobile';
import Portfolio from '../../components/Portfolio/index';
import { DataDafiti } from '../../components/Portfolio/data';

export default function Dafiti() {
  return (
    <>
      <div className="d-none d-lg-block">
        <Portfolio data={DataDafiti} />
      </div>
      <div className="d-block d-lg-none">
        <PortfolioMobile data={DataDafiti} />
      </div>
    </>
  );
}
